<template>
  <div class="ai">
    <h1>{{$t('home.AITitle')}}</h1>
    <div class="ai_items">
      <img src="@/assets/images/W+.png" alt />
      <div>
        <p>{{$t('home.AITitle1')}}</p>
        <p>{{$t('home.AIContent1')}}</p>
      </div>
    </div>
    <div class="ai_items">
      <img src="@/assets/images/maisou.png" alt />
      <div>
        <p>{{$t('home.AITitle2')}}</p>
        <p>{{$t('home.AIContent2')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.ai {
  padding: 36px 20px 47px;
  & > h1 {
    margin-bottom: 24px;
  }
  & .ai_items:last-child {
    margin-bottom: 0px;
  }
  & .ai_items {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    & img {
      width: 110px;
      height: 94.5px;
      margin-right: 5px;
    }
    & div {
      flex: 1;
      & p:first-child {
        font-size: 16px;
        color: #000000;
        letter-spacing: 0;
        margin-bottom: 5px;
      }
      & p:last-child {
        font-size: 12px;
        color: #666666;
        letter-spacing: 0;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
      }
    }
  }
}
</style>